<div class="bm-payment-plan-activity">
    <p-card>
        <div class="p-2">

            <div class="grid">

                <div class="col-12 pt-0">
                    <div class="flex justify-content-between align-items-center border-bottom-1 border-300 pb-3">
                        <div>
                            <h3 class="m-0 text-2xl font-semibold">Zahlungsplan generieren</h3>
                        </div>
                        <div class="flex flex-column gap-3">
                            <div class="flex gap-2 justify-content-end">
                                <p-button label="Validation"></p-button>
                                <p-button label="Process" severity="secondary"></p-button>
                            </div>
                            <div class="flex justify-content-end align-items-center gap-2">
                                <label for="ingredient1">Kunden schriftlich in Kenntnis setzten</label>
                                <p-toggleswitch id="ingredient1"/>
                            </div>
                        </div>
                    </div>
                </div>


                <!--            CHARGES VIEW            -->

                <div class="col-12">
                    <div class="border-bottom-1 border-300 pb-4">

                        <div class="flex align-items-center justify-content-between py-3">
                            <h4 class="m-0 text-2xl font-semibold">Abbrechnungskontobelastung</h4>
                            <div>
                                <p-datePicker disabled="true" [(ngModel)]="selectedDate"/>
                            </div>
                        </div>

                        <div class="grid">


                            <div class="col-12 lg:col-6">
                                <div class="border-1 border-300 border-round-md">

                                    <!-- Header -->
                                    <div class="surface-50 p-3 border-bottom-1 border-300">
                                        <span class="text-lg font-semibold">Abrechnungskonto</span>
                                    </div>

                                    <!-- Rows -->
                                    <div class="billing-rows">

                                        <div
                                                class="billing-row"
                                                *ngFor="let charge of dunningData?.charges; let last = last"
                                                [class.with-divider]="!last"
                                        >

                                            <!-- Left -->
                                            <span>
                                                {{ charge.name }}
                                              </span>

                                            <!-- Right -->

                                            <div>

                                                <!-- EDIT (LEFT) -->

                                                <p-button
                                                        size="small"
                                                        label="Edit"
                                                        [rounded]="true"
                                                        [text]="true"
                                                        [disabled]="isChargeActionDisabled(charge)"
                                                        (click)="openChargeAdjustmentDialog(charge)">
                                                </p-button>

                                                <!-- AMOUNT -->
                                                <span class="bold">
                                                    {{ charge.amount | number:'1.2-2' }} €
                                                  </span>

                                                <!-- TOGGLE BALANCE (RIGHT) -->
                                                <p-button
                                                        [icon]="isChargeInBalance(charge) ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
                                                        size="small"
                                                        [rounded]="true"
                                                        [text]="true"
                                                        [disabled]="!charge.deductable"
                                                        (click)="toggleChargeBalance(charge)">
                                                </p-button>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <!--            CONTRACTS VIEW          -->

                <div class="col-12">

                    <div class="border-bottom-1 border-300 pb-4">


                        <div class="flex justify-content-between align-items-center">
                            <h4 class="text-2xl font-semibold">Detailübersicht Verträge</h4>

                            <div class="flex gap-4 align-items-center">

                                <!-- Terminate all -->
                                <div class="flex align-items-center gap-2">
                                    <p-checkbox
                                            id="terminateAll"
                                            binary="true"
                                            [(ngModel)]="terminateAllChecked"
                                            (onChange)="onTerminateAllToggle($event.checked)">
                                    </p-checkbox>
                                    <label for="terminateAll" class="cursor-pointer">Alle kündigen</label>
                                </div>

                                <!-- Reactivate all -->
                                <div class="flex align-items-center gap-2">
                                    <p-checkbox
                                            id="reactivateAll"
                                            binary="true"
                                            [(ngModel)]="reactivateAllChecked"
                                            (onChange)="onReactivateAllToggle($event.checked)">
                                    </p-checkbox>
                                    <label for="reactivateAll" class="cursor-pointer">Alle reaktivieren</label>
                                </div>

                            </div>
                        </div>


                        <div class="contracts-grid">

                            <div
                                    class="contract-card"
                                    *ngFor="let contract of dunningData?.contracts"
                                    [class.is-new]="contract.status === 'new'"
                            >

                                <!-- Header -->
                                <div class="contract-header">
                                    <div>
                                        <div class="contract-title">{{ contract.type }}</div>
                                    </div>

                                    <div class="flex gap-2 align-items-center bold" (click)="selectContract(contract)">
                                        <i class="pi pi-file text-primary"></i>
                                        <span>{{ contract.identifier }}</span>
                                    </div>
                                </div>

                                <!-- Rows -->
                                <div class="contract-rows">

                                    <!-- Status -->
                                    <div class="contract-row">
                                        <span>Status</span>

                                        <span
                                                class="status-tag"
                                                [ngClass]="getContractBadgeClass(contract)"
                                        >
                                          {{ getContractBadge(contract) }}
                                        </span>
                                    </div>

                                    <!-- Monthly price -->
                                    <div class="contract-row">
                                        <span>{{ contract.partner }}</span>
                                        <span class="amount">
                                          {{ contract.monthlyPrice.at(-1)?.monthlyPrice | number:'1.2-2' }} €
                                        </span>
                                    </div>

                                    <!-- Bis WIK -->
                                    <div
                                            class="contract-row"
                                    >
                                        <span>Bis WIK</span>
                                        <span class="amount">
                                          {{ contract.reactivationAmount | number:'1.2-2' }} €
                                        </span>
                                    </div>

                                    <!-- Rückstand -->
                                    <div
                                            class="contract-row"
                                    >
                                        <span>Rückstand</span>
                                        <span class="amount">
                                          {{ contract.dunningAmount | number:'1.2-2' }} €
                                        </span>
                                    </div>

                                    <!-- WIK / Start Date -->
                                    <div class="contract-row">
                                        <span>{{ contract.status === 'new' ? 'Startdatum' : 'WIK zum' }}</span>

                                        <div class="wik-date">

                                            <i
                                                    class="pi"
                                                    [ngClass]="getContractBadgeIcon(contract)">
                                            </i>

                                            <span [ngClass]="getContractDateClass(contract)">{{ getWikDate(contract) }}</span>
                                        </div>
                                    </div>
                                </div>


                                <div class="contract-actions surface-50">
                                    @if (contract.status !== 'new') {

                                        <div class="flex gap-3 align-items-center">

                                            <div class="flex gap-1 text-red-500 font-medium"
                                                 [class.opacity-70]="contractActivities.get(contract.identifier) !== 'dunning'">
                                                <span>Termination</span>
                                                <span class="font-bold">({{ contract.dunningAmount | number:'1.2-2' }}
                                                    €)</span>
                                            </div>

                                            <p-toggleswitch
                                                    [ngModel]="contractActivities.get(contract.identifier) === 'reactivation'"
                                                    (onChange)="onContractToggleChange(contract, $event.checked)">
                                            </p-toggleswitch>

                                            <div class="flex gap-1 text-primary font-medium"
                                                 [class.opacity-70]="contractActivities.get(contract.identifier) !== 'reactivation'">
                                                <span>ReActivate</span>
                                                <span class="font-bold">({{ contract.reactivationAmount | number:'1.2-2' }}
                                                    €)</span>
                                            </div>

                                        </div>

                                    }

                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <!--            SLIDER VIEW          -->

                <div class="col-12 xl:col-6">

                    <div class="flex align-items-center justify-content-between align-items-center mt-3">
                        <h4 class="text-2xl font-semibold m-0">Payment Plan</h4>
                        <p-button label="One Time Payment" icon="fa-light fa-money-bill" styleClass="gap-0"
                                  variant="outlined"
                                  (click)="openOneTimePaymentDialog()"/>

                    </div>

                    <div class="zahlungsplan-view" *ngIf="dunningData && paymentPlanResult">

                        <div class="zahlungsplan-card">

                            <!-- Slider header -->
                            <div class="slider-header">
                              <span class="slider-label">
                                Months {{ paymentPlanResult.durationMonths }}
                              </span>
                            </div>

                            <!-- Slider -->
                            <div class="slider-wrapper">
                                <p-slider
                                        [(ngModel)]="paybackAmountPerMonth"
                                        [min]="1"
                                        [max]="maxPaybackAmount"
                                        [step]="1"
                                        (onChange)="onPaybackAmountChange($event.value)"
                                        class="w-full"
                                ></p-slider>
                            </div>

                            <!-- Monthly contracts -->
                            <div class="rate-list">

                                <div
                                        class="rate-item flex justify-content-between"
                                        *ngFor="let c of getMonthlyRateContracts()"
                                >
                                    <div class="w-4rem">{{ c.partner }}</div>
                                    <div class="flex justify-content-center w-full">
                                        <span>
                                            {{ c.type }}
                                            @if (isFutureContract(c)) {
                                                ( {{ formatYearMonth(c.monthlyPrice[0]?.startMonth) }}
                                                )
                                            }
                                        </span>
                                    </div>

                                    <div class="w-4rem flex justify-content-end">
                                        {{ getMonthlyPrice(c) | number:'1.2-2' }} €
                                    </div>
                                </div>

                                <div class="rate-item total">
                                    <span>Contribution Rate</span>
                                    <span>
                                      {{ paymentPlanResult.monthlyActiveContractPayments | number:'1.2-2' }} €
                                    </span>
                                </div>

                            </div>

                            <!-- Divider -->
                            <div class="divider"></div>

                            <!-- Payback inputs -->
                            <div class="payback-section">

                                <div class="payback-row">
                                    <span>Rückzahlungssumme</span>
                                    <p-inputNumber
                                            [(ngModel)]="paybackAmountPerMonth"
                                            [min]="1"
                                            [max]="maxPaybackAmount"
                                            [minFractionDigits]="0"
                                            [maxFractionDigits]="0"
                                            style="width: 100px"
                                            (onInput)="onPaybackAmountChange(paybackAmountPerMonth)"
                                    ></p-inputNumber>
                                </div>

                                <div class="payback-row">
                                    <div class="flex align-items-center justify-content-between w-full">
                                        <span>Monate Laufzeit</span>
                                        <span class="date">
                                            ({{ getEndDate(paymentPlanResult.durationMonths) }})
                                          </span>

                                        <p-inputNumber
                                                [(ngModel)]="durationMonths"
                                                [min]="1"
                                                [minFractionDigits]="0"
                                                [maxFractionDigits]="0"
                                                style="width: 100px"
                                                (onInput)="onDurationMonthsChange(durationMonths)"
                                        ></p-inputNumber>
                                    </div>

                                </div>

                            </div>

                            <!-- Total -->
                            <div class="final-row">
                                <span>Total</span>
                                <span>
                                    {{ paymentPlanResult.monthlyTotalPayment | number:'1.2-2' }} €
                                  </span>
                            </div>

                        </div>

                        <!-- CTA -->
                        <button
                                pButton
                                type="button"
                                label="Tilgungsplan generieren"
                                icon="pi pi-file"
                                class="p-button-primary w-full mt-3"
                        ></button>

                    </div>
                </div>

            </div>


        </div>
    </p-card>

</div>


<!-- Charge Adjustment Dialog -->
<p-dialog
        header="Adjust Charge"
        [(visible)]="showChargeAdjustmentDialog"
        [modal]="true"
        [closable]="false"
        [style]="{ width: '460px' }"
        contentStyleClass="p-0">

    <div *ngIf="selectedCharge" class="p-4 flex flex-column gap-4">

        <!-- Charge summary -->
        <div class="flex justify-content-between align-items-center p-3 surface-50 border-round">
            <div class="flex flex-column gap-1">
                <span class="text-sm text-color-secondary">Charge</span>
                <span class="font-semibold">{{ selectedCharge.name }}</span>
            </div>

            <div class="text-right">
                <span class="text-sm text-color-secondary">Original Amount</span>
                <div class="font-semibold">
                    {{ selectedCharge.amount | number:'1.2-2' }} EUR
                </div>
            </div>
        </div>

        <!-- Adjustment type -->
        <div class="flex flex-column gap-2">
            <label class="font-medium text-sm">Adjustment Type</label>

            <div class="flex gap-2">
                <p-button
                        label="Remove"
                        icon="pi pi-trash"
                        [disabled]="!selectedCharge.deductable"
                        class=" w-full"
                        styleClass=" w-full"
                        [ngClass]="{ 'p-button-outlined': chargeAdjustmentType !== 'remove' }"
                        (click)="chargeAdjustmentType = 'remove'">
                </p-button>

                <p-button
                        label="Reduce"
                        icon="pi pi-minus"
                        [disabled]="!selectedCharge.reducable"
                        class=" w-full"
                        styleClass=" w-full"
                        [ngClass]="{ 'p-button-outlined': chargeAdjustmentType !== 'reduce' }"
                        (click)="chargeAdjustmentType = 'reduce'">
                </p-button>
            </div>
        </div>

        <!-- Reduced amount -->


        <div *ngIf="chargeAdjustmentType === 'reduce'"
             class="flex flex-column gap-1">

            <label class="font-medium text-sm">
                New Amount (EUR) <span class="text-red-500">*</span>
            </label>

            <p-inputNumber
                    [(ngModel)]="reducedChargeAmount"
                    [min]="0"
                    [max]="selectedCharge.amount"
                    mode="decimal"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    class="w-full"
                    [ngClass]="{ 'p-invalid': isReduceAmountInvalid }">
            </p-inputNumber>

            <small *ngIf="isReduceAmountInvalid" class="text-red-500">
                Amount must be greater than 0 and less than the original amount
            </small>

            <small *ngIf="!isReduceAmountInvalid" class="text-color-secondary">
                Must be less than the original amount
            </small>
        </div>

    </div>

    <div class="flex justify-content-end gap-2 p-3 border-top-1 surface-border">
        <p-button
                label="Cancel"
                class="p-button-text"
                (click)="showChargeAdjustmentDialog = false">
        </p-button>

        <p-button
                label="Apply & Add"
                icon="pi pi-check"
                [disabled]="!isChargeAdjustmentValid"
                (click)="applyChargeAdjustment()">
        </p-button>
    </div>

</p-dialog>

<!-- One-Time Payment Dialog -->

<bm-one-time-payment-dialog
        [(visible)]="showOneTimePaymentDialog">
</bm-one-time-payment-dialog>

<p-popover #pricePanel [dismissable]="true" styleClass="price-overlay">
    <ng-template pTemplate="content">
        <div class="flex flex-column gap-2 min-w-15rem">
            <div
                    *ngFor="let price of selectedContractForPriceView?.monthlyPrice"
                    class="flex gap-2 text-sm"
            >
                <span>{{ price.startMonth | date: 'MMM yyyy' }}</span>
                <strong>{{ price.monthlyPrice | number:'1.2-2' }} €</strong>
            </div>
        </div>
    </ng-template>
</p-popover>
